import { CoreCircularProgress } from '@ingenico/react-ui/core-circular-progress';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import classNames from 'classnames';
import { toString } from 'lodash-es';
import type { ReactNode } from 'react';
import type { CircularPercentageInfoProps } from './CircularPercentageInfo.model';
import styles from './CircularPercentageInfo.module.scss';
import { getColorByValue } from './CircularPercentageInfo.util';

export function CircularPercentageInfo({
  value,
  title,
  subtitle,
  children,
  inverse,
  componentsClassNames,
}: CircularPercentageInfoProps): ReactNode {
  const coreCircularProgressClassName = classNames({
    [styles.circularPercentageInfo__red]: getColorByValue(value, inverse) === 'red',
    [styles.circularPercentageInfo__yellow]: getColorByValue(value, inverse) === 'yellow',
    [styles.circularPercentageInfo__blue]: getColorByValue(value, inverse) === 'blue',
    [styles.circularPercentageInfo__green]: getColorByValue(value, inverse) === 'green',
  });

  return (
    <div className={classNames(styles.circularPercentageInfo__container, toString(componentsClassNames?.container))}>
      <CoreCircularProgress
        value={value}
        valueClassName={classNames(
          coreCircularProgressClassName,
          toString(styles.circularPercentageInfo__chartContainer),
        )}
      >
        <div
          className={classNames(
            styles.circularPercentageInfo__iconContainer,
            coreCircularProgressClassName,
            toString(componentsClassNames?.childContainer),
          )}
        >
          {children}
        </div>
      </CoreCircularProgress>
      <div className={styles.circularPercentageInfo__typoContainer}>
        <CoreTypography
          customClassName={styles.circularPercentageInfo__nameTypography}
          tooltipTitle={title}
          truncateText
          variant={CoreTypographyVariant.Body02Regular}
        >
          {title}
        </CoreTypography>
        <CoreTypography tooltipTitle={subtitle} truncateText variant={CoreTypographyVariant.Body01Medium}>
          {subtitle}
        </CoreTypography>
      </div>
    </div>
  );
}
